import React from 'react'
import map from 'lodash/map'
import { Item, Popup, Icon, Button, Label } from 'semantic-ui-react'

import utils from '../../../utils'

const options = [
  { key: 1, text: 'All', value: 'all' },
  { key: 7, text: 'Scheduled', value: 'scheduled' },
  { key: 2, text: 'Attention', value: 'attention' },
  { key: 3, text: 'Confirmed', value: 'confirmed' },
  { key: 4, text: 'Out for Delivery', value: 'outForDelivery' },
  { key: 5, text: 'Delivered', value: 'delivered' },
  { key: 6, text: 'Rejected', value: 'rejected' },
]

export default class OrderTab extends React.PureComponent {
  renderOption = option => {
    const { drivers, activeTab, todayOrders, onChange } = this.props

    const orders = todayOrders[option.value] || []
    const orderCount = orders.length
    let needSupportCount = 0
    let countDriverPending = 0
    let switchOrderCount = 0
    const pendingDrivers = []

    const hasAttentionScheduleOrder = utils.order.hasAttentionScheduleOrders(orders)
    const isNeedSupportShowAble = !['all', 'delivered', 'rejected'].includes(option.value)
    const shouldShowSwitchOrder = ['confirmed', 'outForDelivery'].includes(option.value)

    for (let i = 0; i < orders.length; i += 1) {
      const order = orders[i]
      if (order.support_needed || order.restaurant_need_support) {
        needSupportCount += 1
      }

      if (order.driver_pending_order) {
        countDriverPending += 1

        const driver = drivers[order.driver_pending_order]

        if (driver)
          pendingDrivers.push(
            <Item.Description key={driver.tel}>{`-  ${driver.family_name} ${
              driver.first_name
            }`}</Item.Description>
          )
      }

      if (Object.values(order.operators || {}).length > 1) {
        switchOrderCount += 1
      }
    }

    return (
      <Button
        onClick={() => onChange(option)}
        key={option.key}
        basic={option.value !== activeTab}
        color="black"
      >
        {option.text}
        <Label style={{ position: 'relative', marginLeft: 5 }} color="grey" circular>
          {orderCount}
          {option.value === 'scheduled' && hasAttentionScheduleOrder && (
            <Label circular color="red" empty style={{ position: 'absolute', top: -3, right: -3 }} />
          )}
        </Label>
        {needSupportCount > 0 && isNeedSupportShowAble && (
          <Label style={{ marginLeft: 5 }} color="orange" circular>
            {needSupportCount}
          </Label>
        )}

        {countDriverPending > 0 && isNeedSupportShowAble && (
          <Popup
            position="bottom center"
            trigger={
              <Label style={{ marginLeft:5 }} color="orange" circular>
                <Icon name="bicycle" /> {countDriverPending}
              </Label>
            }
          >
            {pendingDrivers}
          </Popup>
        )}

        {shouldShowSwitchOrder && switchOrderCount > 0 && (
          <Label style={{ marginLeft: 5 }} color="orange" circular>
            <Icon name="exchange" /> {switchOrderCount}
          </Label>
        )}
      </Button>
    )
  }

  render() {
    return <Button.Group fluid>{map(options, this.renderOption)}</Button.Group>
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderTabBar.js